module.exports = __webpack_public_path__ + "media/images/semen_import_sheet-179f5f2f308b018ad96e052de30de2bb.png";